import React from 'react'

import icons from './../../utils/import.icons'

interface Properties {
    CurrentCar?: any
    handleBackBtn?: any
    handleFichasBtn?: any
    handleGalleryBtn?: any
    handleInteriorBtn?: any
    handleVista180?: any
    isFichas?: boolean,
    isGaleria?: boolean,
    isInterior?: boolean,
    Icon?: any,
    is180?: boolean
}

const CarComponent = (property: Properties) =>  {

        const mapa: any = {icons}
        const Icon = mapa.icons[property.CurrentCar.Nombre + " BLACK"] 

        return (
                <div className = "sidebar-car">
                    <button className = "back-btn" onClick = {() => property.handleBackBtn()}>
                        <img src = {icons["back"]}alt=''></img>
                    </button>
                    <div className = "car-name">
                        <img className = "car-name-image" src={Icon}></img>
                    </div>
                    <hr className = "hr-sidebar"></hr>
                    <div className = "button-container">
                        <button className = {property.is180 ? "sidebar-btn selected":"sidebar-btn"} onClick = {() => property.handleVista180(property.CurrentCar)}>
                            <img src = {property.is180 ? icons["1802"]:icons["180"]} alt=''></img>
                            <span>
                                Spin Exterior
                            </span>
                        </button>
                        <button className = {property.isInterior ? "sidebar-btn selected":"sidebar-btn"} onClick = {() => property.handleInteriorBtn(property.CurrentCar)}>
                            <img src = {property.isInterior ? icons["3602"]:icons["360"]} alt=''></img>
                            <span>
                                Interior 360°
                            </span>
                        </button>
                        <button className = {property.isGaleria ? "sidebar-btn selected":"sidebar-btn"} onClick = {() => property.handleGalleryBtn(property.CurrentCar)}>
                            <img src = {property.isGaleria ? icons["Galeria2"]:icons["Galeria"]} alt=''></img>
                            <span>
                                Galería
                            </span>
                        </button>
                        <button className = {property.isFichas ? "sidebar-btn selected":"sidebar-btn"} onClick = {() => property.handleFichasBtn(property.CurrentCar)}>
                            <img src = {property.isFichas ? icons["ficha2"]:icons["ficha"]} alt=''></img>
                            <span>
                                Ficha técnica
                            </span>
                        </button>
                    </div>
                    <div className = "follow-container">
                        <span>Síguenos</span>
                        <div className = "social-container">
                            <a className = "social-btn" href="https://www.facebook.com/BYDAutoColombia/" target="_blank" rel='noreferrer'>
                                <img src = {icons["Facebook"]} alt=''></img>
                            </a>
                            <a className = "social-btn" href="https://www.instagram.com/bydautocolombia/?hl=es-la" target="_blank" rel='noreferrer'>
                                <img src = {icons["Insta"]} alt=''></img>
                            </a>
                            <a className = "social-btn" href="https://www.youtube.com/channel/UC5T2CarA3VHbF6buuvcWPXA" target="_blank" rel='noreferrer'>
                                <img src = {icons["Youtube"]} alt=''></img>
                            </a>
                        </div>
                    </div>
                </div>
        );
}

export default  CarComponent;